import { ValueUom } from '../utils/type'

export function handleFetchErrors(response: Response): Promise<any> {
    if (!response.ok) {
        return Promise.reject(response)
    }

    return Promise.resolve(response)
}

interface AttributeUnity {
    id: number
    unitOfMeasure_id: number
    value: number
    name: string
}

export function isAttributeUnit(object: unknown): object is AttributeUnity {
    return (
        object &&
        Object.prototype.hasOwnProperty.call(object, 'id') &&
        Object.prototype.hasOwnProperty.call(object, 'unitOfMeasure_id') &&
        Object.prototype.hasOwnProperty.call(object, 'value') &&
        Object.prototype.hasOwnProperty.call(object, 'name')
    )
}

// convert AttributeUnity to ValueUom
export function entityReviver(key, value) {
    if (isAttributeUnit(value)) {
        const valueUom: ValueUom = {
            uom: {
                id: value.id,
                name: value.name,
                unitOfMeasure_id: value.unitOfMeasure_id
            },
            value: value.value
        }

        return valueUom
    }

    return value
}

export function isValueUom(object: unknown): object is ValueUom {
    return (
        object &&
        Object.prototype.hasOwnProperty.call(object, 'uom') &&
        Object.prototype.hasOwnProperty.call(object, 'value')
    )
}

// convert ValueUom to AttributeUnity
export function entityReplacer(key, value) {
    if (isValueUom(value)) {
        if (!value.uom) return null
        const attributeUnit: AttributeUnity | any = {}
        Object.entries(value.uom).forEach(entry => (attributeUnit[entry[0]] = entry[1]))
        attributeUnit.value = value.value

        return attributeUnit
    }

    return value
}
